var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgQuestion2 = function SvgQuestion2(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 25,
    fill: "none",
    viewBox: "0 0 15 25",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.672 16.422v-1.156c0-1 .213-1.87.64-2.61.428-.74 1.209-1.526 2.344-2.36C8.75 9.517 9.47 8.88 9.813 8.392c.354-.49.53-1.037.53-1.641 0-.677-.25-1.193-.75-1.547-.5-.354-1.197-.531-2.093-.531-1.563 0-3.344.51-5.344 1.531L.453 2.781C2.776 1.48 5.24.828 7.843.828c2.147 0 3.85.516 5.11 1.547C14.224 3.406 14.86 4.781 14.86 6.5c0 1.146-.26 2.135-.78 2.969-.522.833-1.511 1.77-2.97 2.812-1 .74-1.635 1.302-1.906 1.688-.26.385-.39.89-.39 1.515v.938H4.671Zm-.5 5.344c0-.875.234-1.537.703-1.985.469-.448 1.151-.672 2.047-.672.864 0 1.531.23 2 .688.479.458.719 1.114.719 1.969 0 .823-.24 1.474-.72 1.953-.478.468-1.145.703-2 .703-.874 0-1.551-.23-2.03-.688-.48-.468-.72-1.125-.72-1.968Z"
  })));
};
export default SvgQuestion2;